class BESSAppLogin extends BESSAppBase {

    constructor() {
        super();
        this.root = $('.page-login');
        if (this.root.length === 0) {
            return;
        }
        this.inputEmail = $('#id_email');
        this.inputPassword = $('#id_password');
        this.loginBtn = this.root.find('.app-login');
        this.invalidCredentials = this.root.find('.app-invalid-credentials');
        this.forgottenPasswordLink = this.root.find('.app-forgotten-password');
        this.forgottenPasswordLink.bindClickEvent(this, this.#onForgottenPassword);

        this.form = this.root.find('form');
        this.form.submit(this.#onLoginUser.bind(this));

        if (this.root.hasClass('app-invalid-forgotten-password-link')) {
            this.informUser("Invalid link", "Sorry, that link is no longer valid");
        }
    }

    #onLoginUser(e) {
        e.preventDefault();
        this.invalidCredentials.addClass('hidden');
        let email = this.inputEmail.val().trim();
        let password = this.inputPassword.val().trim();
        this.log('#onLoginUser');

        this.loginBtn.disableControl();
        this.loginBtn.addClass('app-saving');
        BESSApp.instance.services.api.auth.loginUser(
            email,
            password,
            this.#onLoginUserSuccess.bind(this),
            this.#onLoginUserFailed.bind(this),
        )
        return false;
    }

    #onLoginUserSuccess() {
        window.location.reload();
    }

    #onLoginUserFailed() {
        this.invalidCredentials.removeClass('hidden');
        this.loginBtn.enableControl();
        this.loginBtn.removeClass('app-saving');
    }

    #onForgottenPassword() {
        let email = this.inputEmail.val().trim();
        this.askForTextInput(
            "Forgotten password",
            "<p>Please enter the email address for your account. We will send instructions to login to this email.</p>",
            email,
            this.#onRequestForgottenPassword.bind(this));
    }

    #onRequestForgottenPassword(email) {
        BESSApp.instance.services.api.auth.forgottenPassword(email);
        this.informUser(
            'Forgotten password',
            '<p>If your email matches a registered user, an email with instructions to login will have been sent to that email address.</p>'
        );
    }
}